import { useEffect, useMemo, useRef } from 'react';
import { fetchListTopic } from '../../../../apis/discovery.api';
import { useState } from 'react';
import TopicContainerCustom from '../../../TopicContainerCustom';
import Cookies from 'js-cookie';
import {
  Box,
  Button,
  Checkbox,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure
} from '@chakra-ui/react';
import { ReactComponent as ArrowDownWhiteIcon } from '../../../../assets/arrow-down-white-icon.svg';
import { TAB_LIST_DISCOVERY } from '../../../../constants/article.constant';
import FeedSettingsModal from '../../../../components/CustomFeeds';
import { Sliders } from 'lucide-react';

const ListFilter = ({ selected, setSelected, setPagination, setSearchParams }) => {
  const [listTopic, setListTopic] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState([]);
  const isFetched = useRef(false);
  const { isOpen, onToggle, onClose } = useDisclosure();
  const [isFeedSettingsOpen, setIsFeedSettingsOpen] = useState(false);
  const token = Cookies.get('token');

  const filterListItem = [
    {
      name: 'For You',
      value: TAB_LIST_DISCOVERY.FOR_YOU,
      isHidden: !token
    },
    {
      name: 'Perspectives',
      value: TAB_LIST_DISCOVERY.PERSPECTIVES,
      isNew: true
    },
    // {
    //   name: 'Breaking News',
    //   value: TAB_LIST_DISCOVERY.BREAKING
    // },
    {
      name: 'Recent',
      value: TAB_LIST_DISCOVERY.RECENT
    },
    {
      name: 'Following',
      value: TAB_LIST_DISCOVERY.FOLLOWING,
      isHidden: !token
    },
    {
      name: 'My Reading List',
      value: TAB_LIST_DISCOVERY.MY_READING,
      isHidden: !token
    },
    {
      name: 'Categories',
      value: TAB_LIST_DISCOVERY.CATEGORIES
    }
    // {
    //   name: 'News Hub',
    //   value: TAB_LIST_DISCOVERY.NEWS_HUB
    // }
  ];

  const sortedTopics = useMemo(() => {
    return listTopic?.sort((a, b) => {
      const isSelectedA = selectedTopic.some((item) => item.id === a.id);
      const isSelectedB = selectedTopic.some((item) => item.id === b.id);
      return isSelectedB - isSelectedA;
    });
  }, [listTopic, selectedTopic]);

  const handleChangeTab = (value) => {
    if (value === TAB_LIST_DISCOVERY.CATEGORIES) {
      onToggle();
    } else {
      setSelectedTopic([]);
      setSearchParams({ tab: value });
    }

    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  useEffect(() => {
    if (selected.type !== TAB_LIST_DISCOVERY.CATEGORIES) {
      setSelectedTopic([]);
    }
  }, [selected.type]);

  const handleSelectedTopicCategories = (topic) => {
    setSelectedTopic((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.id === topic.id);

      const newList = isAlreadySelected
        ? prevSelected.filter((item) => item.id !== topic.id)
        : [...prevSelected, { id: topic.id, name: topic.name }];

      setSelected((prev) => ({
        ...prev,
        topic: newList.map((item) => item.id)
      }));

      // ✅ ADD THIS: persist to URL
      setSearchParams({
        tab: TAB_LIST_DISCOVERY.CATEGORIES,
        topics: newList.map((item) => item.id).join(',')
      });

      return newList;
    });
  };

  useEffect(() => {
    if (!isFetched.current) {
      fetchListTopic()
        .then((result) => setListTopic(result))
        .catch((error) => console.error(error));
      isFetched.current = true;
    }
  }, []);

  useEffect(() => {
    if (!listTopic.length) return;

    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    const topicsParam = params.get('topics');

    if (tab !== TAB_LIST_DISCOVERY.CATEGORIES || !topicsParam) return;

    const topicIds = topicsParam.split(',').map(Number);

    const restoredTopics = listTopic
      .filter((topic) => topicIds.includes(topic.id))
      .map((topic) => ({ id: topic.id, name: topic.name }));

    if (restoredTopics.length) {
      setSelectedTopic(restoredTopics);

      setSelected((prev) => ({
        ...prev,
        type: TAB_LIST_DISCOVERY.CATEGORIES,
        topic: restoredTopics.map((t) => t.id)
      }));
    }
  }, [listTopic]);

  return (
    <div className="sticky top-[68px] md:top-[76px] w-full flex flex-col gap-3 justify-end bg-white">
      <div className="h-[70px] flex px-1 gap-2 md:gap-4 pb-3 md:pb-1 overflow-x-auto w-full pt-3 md:pt-5 scrollbar-on-hover">
        {/* Feed Settings Button */}
        {token && (
          <button
            onClick={() => setIsFeedSettingsOpen(true)}
            className={
              'flex items-center gap-2 px-3 py-1 md:px-[14px] md:py-[8.5px] h-9 rounded-[8px] border-[2px] border-solid border-growth-green text-growth-green font-extrabold text-sm whitespace-nowrap transition duration-200 hover:opacity-70' +
              (isFeedSettingsOpen ? ' bg-growth-green text-white' : '')
            }
            style={{ minWidth: 'fit-content' }}
          >
            <Sliders className="w-4 h-4 rotate-90" />
            <span className="hidden md:inline">Feed Settings</span>
          </button>
        )}
        {filterListItem?.map((item, index) => {
          if (item.value === 'categories') {
            // Render the Categories menu
            return (
              <Menu key={index} isOpen={isOpen} onClose={onClose} closeOnSelect={false}>
                <MenuButton
                  onClick={() => handleChangeTab(item.value)}
                  as={Button}
                  rightIcon={
                    <ArrowDownWhiteIcon
                      className={`w-[20px] h-[20px] transition duration-300 ${isOpen ? 'transform rotate-180' : 'transform rotate-0'}`}
                      alt=""
                    />
                  }
                  zIndex={1000}
                  maxHeight={9}
                  textAlign={'start'}
                  className={`${item.isHidden ? '!hidden' : ''} px-3 py-1 md:py-[8.5px] md:px-[14px]`}
                  rounded={'8px'}
                  _active={{ bg: 'growth-green', textColor: 'white' }}
                  _hover={{ opacity: 0.7 }}
                  bg={selected.type === item.value ? 'growth-green' : 'unset'}
                  borderWidth={'2px'}
                  borderColor={'growth-green'}
                  color={selected.type === item.value ? 'white' : 'growth-green'}
                  fontSize={'sm'}
                  fontWeight={'800'}
                  lineHeight={'1.25rem'}
                  whiteSpace={'nowrap'}
                >
                  Categories {selectedTopic.length > 0 && <span>({selectedTopic.length})</span>}
                </MenuButton>
                <MenuList
                  p={'0.625rem'}
                  shadow={'md'}
                  border={'1px solid light-gray'}
                  borderRadius={'8px'}
                  display={'flex'}
                  flexDir={'column'}
                  gap={'4px'}
                  w={'fit-content'}
                  maxH={'250px'}
                  minW={'unset'}
                  overflow={'auto'}
                  css={{
                    '&::-webkit-scrollbar': { width: '6px' },
                    '&::-webkit-scrollbar-track': { width: '6px' },
                    '&::-webkit-scrollbar-thumb': { background: '#c6ceda', borderRadius: '20px' }
                  }}
                >
                  {sortedTopics?.map((elm, index) => {
                    const isSelected = selectedTopic.some((item) => item.id === elm.id);

                    return (
                      <MenuItem
                        key={index}
                        onClick={(e) => {
                          e.preventDefault();
                          handleSelectedTopicCategories(elm);
                          setPagination((prevPagination) => ({ ...prevPagination, page: 1 }));
                        }}
                        _hover={{ bgColor: 'anti-flash-white' }}
                        rounded={'0.5rem'}
                        py={'8px'}
                        px={'10px'}
                        _focus={{ bgColor: 'anti-flash-white' }}
                        fontSize={'xs'}
                        fontWeight={'800'}
                      >
                        <Box display="flex" gap="10px">
                          <Checkbox
                            size={'sm'}
                            isChecked={isSelected}
                            onChange={(e) => {
                              e.preventDefault();
                              handleSelectedTopicCategories(elm);
                            }}
                          />
                          {elm.name}
                        </Box>
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </Menu>
            );
          }

          // Render regular filter list items
          return (
            <div
              key={index}
              onClick={() => handleChangeTab(item.value)}
              className={`${item.isHidden ? 'hidden' : ''} px-3 py-1 md:px-[14px] md:py-[8.5px] ${
                selected.type === item.value ? 'bg-growth-green text-white' : 'text-growth-green'
              } cursor-pointer border-[2px] border-solid border-growth-green hover:opacity-70 h-9 transition duration-200 rounded-[8px] flex items-center gap-1.5 text-sm font-extrabold whitespace-nowrap`}
            >
              {item.name}
              {item.isNew && (
                <span
                  className={`text-[9px] font-bold px-1.5 py-0.5 rounded ${
                    selected.type === item.value
                      ? 'bg-white/20 text-white'
                      : 'bg-growth-green/10 text-growth-green'
                  }`}
                >
                  NEW
                </span>
              )}
            </div>
          );
        })}
      </div>
      {selectedTopic?.length > 0 ? (
        <div className="text-growth-green-900 font-[700] mt-4">
          Filtered by:{' '}
          {selectedTopic.slice(0, 2).map((item, index) => (
            <span key={index}>
              {item.name}
              {index < Math.min(1, selectedTopic.length - 1) ? ', ' : ''}
            </span>
          ))}
          {selectedTopic.length > 2 && <span>, +{selectedTopic.length - 2} more.</span>}
        </div>
      ) : (
        <></>
      )}

      {selected.type === TAB_LIST_DISCOVERY.MY_READING && (
        <TopicContainerCustom
          topicLabels={listTopic}
          selected={selected}
          setSelected={setSelected}
          setPagination={setPagination}
        />
      )}
      <FeedSettingsModal open={isFeedSettingsOpen} onOpenChange={setIsFeedSettingsOpen} />
    </div>
  );
};

export default ListFilter;
